import { createContext, useContext, useEffect, useState } from 'react';
import type { WhiteboardSummary } from '@lens/shared';
import { apiRequest } from '../../shared/api/client.ts';

/** Как часто обновлять отметки «есть доска» — в такт обновлению таблицы. */
const REFRESH_MS = 60_000;

export async function getWhiteboardSummary(spaceId: string): Promise<WhiteboardSummary> {
  return apiRequest<WhiteboardSummary>(`/api/spaces/${spaceId}/whiteboards`, { method: 'GET' });
}

/**
 * Записи пространства с непустой доской. Обновляется раз в минуту и при
 * возврате во вкладку; ошибки молча пропускаем — это лишь отметка.
 */
export function useWhiteboardSummary(spaceId: string | undefined): WhiteboardSummary['boards'] {
  const [boards, setBoards] = useState<WhiteboardSummary['boards']>({});
  useEffect(() => {
    if (!spaceId) return;
    let cancelled = false;
    const load = () => {
      getWhiteboardSummary(spaceId)
        .then((s) => {
          if (!cancelled) setBoards(s.boards);
        })
        .catch(() => undefined);
    };
    load();
    const timer = setInterval(load, REFRESH_MS);
    const onVisible = () => {
      if (document.visibilityState === 'visible') load();
    };
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      cancelled = true;
      clearInterval(timer);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [spaceId]);
  return boards;
}

/** Сводка досок для глубоко вложенных карточек канбана — без проброса пропом. */
export const WhiteboardSummaryContext = createContext<WhiteboardSummary['boards']>({});

export function useWhiteboardBoards(): WhiteboardSummary['boards'] {
  return useContext(WhiteboardSummaryContext);
}
